import type { Theme } from "react95/dist/themes/types";

// All-pink custom theme based on candy theme
export const pinkTheme: Theme = {
  name: "zapychan",
  anchor: "#ff1493",
  anchorVisited: "#cc1177",
  borderDark: "#d4578a",
  borderDarkest: "#b03060",
  borderLight: "#ffcce0",
  borderLightest: "#ffe4f0",
  canvas: "#fff0f5",
  canvasText: "#8b0045",
  canvasTextDisabled: "#d4578a",
  canvasTextDisabledShadow: "#ffe4f0",
  canvasTextInvert: "#fff0f5",
  checkmark: "#ff1493",
  checkmarkDisabled: "#d4578a",
  desktopBackground: "#ffc0cb",
  flatDark: "#d4578a",
  flatLight: "#ffb6c1",
  focusSecondary: "#ffe4f0",
  headerBackground: "#ff69b4",
  headerNotActiveBackground: "#dda0dd",
  headerNotActiveText: "#fff0f5",
  headerText: "#ffffff",
  hoverBackground: "#ff69b4",
  material: "#ffb6c1",
  materialDark: "#f08cbb",
  materialText: "#8b0045",
  materialTextDisabled: "#d4578a",
  materialTextDisabledShadow: "#ffe4f0",
  materialTextInvert: "#fff0f5",
  progress: "#ff69b4",
  tooltip: "#ffffcc",
};
